import {createStore} from 'vuex';

const store = createStore({
    state() {
        return {
            scrollY: 0, eventContentData: null
        };
    }, mutations: {
        setScrollY(state, value) {
            state.scrollY = value;
        }, setEventContentData(state, data) {
            state.eventContentData = data;
        }
    }, actions: {
        updateScrollY({commit}, value) {
            commit('setScrollY', value);
        }, updateEventContentData({commit}, value) {
            commit('setEventContentData', value);
        }
    }, getters: {
        getScrollY(state) {
            return state.scrollY;
        }, getEventContentData(state) {
            return state.eventContentData;
        },
    }
});

export default store;